import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";

/* eslint-disable max-classes-per-file */

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { functionName } from './utils';
import './vanilla';
import './cash-dom';
/*----------------------------------------------------*/
// Methods

/*----------------------------------------------------*/

export var performance = {
  now: function now() {
    return (window.performance.now() / 1000 % 60).toFixed(3);
  }
}; // eslint-disable-next-line no-underscore-dangle

export var app = function app() {
  return window[__VARNAME__];
}; // Plugin install method
// --------------------------------------------------

export function register() {
  var registry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var module = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var fn; // look for a install static method

  if (typeof module.install === 'function') {
    fn = module.install;
  }

  if (!fn) {
    throw new Error("".concat(functionName(module), ".install static method or function not found"));
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  registry.push({
    module: module,
    args: args
  });
}
export function attach() {
  var registry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var scope = arguments.length > 1 ? arguments[1] : undefined;
  registry.forEach(function (p) {
    var _module$install;

    var module = p.module,
        args = p.args;

    (_module$install = module.install).call.apply(_module$install, [scope, module].concat(_toConsumableArray(args)));
  });
} // Mixin builder
// --------------------------------------------------

var MixinBuilder = /*#__PURE__*/function () {
  function MixinBuilder(superclass) {
    _classCallCheck(this, MixinBuilder);

    this.superclass = superclass || /*#__PURE__*/function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      return _createClass(_class);
    }();
  }

  _createClass(MixinBuilder, [{
    key: "with",
    value: function _with() {
      for (var _len2 = arguments.length, mixins = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        mixins[_key2] = arguments[_key2];
      }

      return mixins.reduce(function (c, m) {
        return m(c);
      }, this.superclass);
    }
  }]);

  return MixinBuilder;
}();

export var mix = function mix(superclass) {
  return new MixinBuilder(superclass);
};
export default {};

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}